import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface AuthStore {
    idToken?: {
        SS?: string
    },
    refreshToken?: {
        ID?: string
        SS?: string
        UID?: string
    },
    user?: any

    setIdToken: (idToken: { SS?: string }) => void
    setRefreshToken: (refreshToken: { ID?: string, SS?: string, UID?: string }) => void
    setUser: (user: any) => void
    clearAuth: () => void
}

export const useAuthStore = create<AuthStore>()(
    persist(
        (set) => ({
            idToken: null,
            refreshToken: null,
            user: null,

            setIdToken: (idToken: { SS?: string }) => {
                set({ idToken })
            },

            setRefreshToken: (refreshToken: { ID?: string, SS?: string, UID?: string }) => {
                set({ refreshToken })
            },
            
            setUser: (user: any) => {
                set({ user })
            },

            clearAuth: () => {
                set({ idToken: undefined, refreshToken: undefined, user: undefined })
            },
        }),
        {
            name: 'auth-storage',
            storage: createJSONStorage(() => localStorage),
        }
    )
);
